module.exports = __webpack_public_path__ + "fromGroomToParents-jp-b.f60546cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-jp-b.jpg
// module id = C2pC
// module chunks = 0